import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { tomos } from '../data/megapack';
import { SectionHeading } from './SectionHeading';
import { useReveal } from '../hooks/useReveal';
export function TomosSection() {
  const gridRef = useReveal<HTMLDivElement>();
  return <section id="tomos" className="w-full bg-cream px-5 py-16 sm:py-20" aria-labelledby="tomos-title" data-id="element-274" data-mp="1u2dlcu1hgo8t">
      <div className="mx-auto max-w-5xl" data-id="element-275" data-mp="xcnv0104ysld">
        <div className="text-center" data-id="element-276" data-mp="xdyuhomjte6o">
          <BookOpenIcon className="mx-auto h-9 w-9 text-forest-800" aria-hidden="true" data-id="element-277" data-mp="11dzls9uqxjv5" />
        </div>
        <div className="mt-4" data-id="element-278" data-mp="16d2h32kxcbpx">
          <SectionHeading id="tomos-title" eyebrow="Contenido principal" title={<>
                Los <span className="mark-lime" data-id="element-280" data-mp="1bcfdof1lkx5p">6 tomos</span> del MegaPack
              </>} subtitle="Material completo para sala de 3, 4 y 5 años" data-id="element-279" data-mp="16cswxvmk8ys5" />
        </div>

        <div ref={gridRef} className="reveal-group mt-12 grid gap-5 lg:grid-cols-2" data-id="element-281" data-mp="2huc0xq7yt5rr">
          {tomos.map((tomo, index) => <article key={tomo.id} style={{
          transitionDelay: `${index % 2 * 60}ms`
        }} className="reveal flex flex-col rounded-3xl border-2 border-forest-100 bg-white p-6 shadow-card transition-colors duration-300 hover:border-lime-200" data-id="element-282" data-mp="2qo8j5hgvhohl" data-mpi={index}>
              <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-forest-700" data-id="element-283" data-mp="2hlzakx56056u">
                <span className={`h-2.5 w-2.5 rounded-full ${tomo.dot}`} aria-hidden="true" data-id="element-284" data-mp="2cqjz2bumqldl" />
                {tomo.badge}
              </p>
              <h3 className="mt-2 font-display text-xl font-extrabold leading-snug text-forest-800" data-id="element-285" data-mp="22y4kloijkexg">
                {tomo.title}
              </h3>
              <p className="mt-1 font-hand text-lg text-forest-400" data-id="element-286" data-mp="1yxawov53n04k">{tomo.tagline}</p>

              <p className="mt-4 text-[13px] leading-relaxed text-forest-900/75" data-id="element-287" data-mp="1tzj3lxspx7ys">{tomo.resuelve}</p>

              <ul className="mt-4 space-y-1.5" data-id="element-288" data-mp="1oyd5fkgagshv">
                {tomo.incluye.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-forest-900/80" data-id="element-289" data-mp="1k0tkk1p35hgy">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-lime-600" aria-hidden="true" data-id="element-290" data-mp="1ab4pk6c1byzk" />
                    {item}
                  </li>)}
              </ul>

              <p className="mt-auto pt-5" data-id="element-291" data-mp="11bztd6ny4hqk">
                <span className="block rounded-2xl border-2 border-lime-200 bg-lime-100 p-3.5 text-[13px] leading-snug text-forest-800" data-id="element-292" data-mp="11d2l1gt3eo7j">
                  <span className="font-display font-extrabold uppercase tracking-wide text-forest-700" data-id="element-293" data-mp="1t2nre9ubp700">
                    Resultado:{' '}
                  </span>
                  {tomo.resultado}
                </span>
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}